export default "__VITE_ASSET__DbXzbitv__"